import { iconCircularButtonArrow, iconCircularButtonCalm } from '../../utils/icons'

let highchartsInitialised = false

export const initialiseHighcharts = (Highcharts) => {
  if (highchartsInitialised) return

  Highcharts.setOptions({
    palette: {
      colorScheme: 'light',
    },
    chart: {
      backgroundColor: '#FFF',
      zooming: {
        mouseWheel: false,
      },
    },
    credits: {
      enabled: false,
    },
  })

  Highcharts.wrap(Highcharts.PlotLineOrBand.prototype, 'render', function (proceed) {
    const chart = this.axis.chart
    proceed.call(this)

    if (!chart.seriesGroup) {
      chart.seriesGroup = chart.renderer.g('series-group')
        .attr({ zIndex: 3 })
        .add()
    }

    if (this.svgElem.parentGroup !== chart.seriesGroup) {
      this.svgElem
        .attr({ zIndex: this.options.zIndex })
        .add(chart.seriesGroup)
    }

    return this
  })

  highchartsInitialised = true
}

export const attachWindDirectionRedrawHandler = ({ options, convertDegreesToIconAngle }) => {
  const windDirectionSeries = options.series.slice().filter(({ id }) => id.match(/^wind_direction/))

  if (!windDirectionSeries.length || !options.chart.events) {
    return options
  }

  let proceedWithIconRender = true
  let lastViewXAxisMin = null
  let lastViewXAxisMax = null
  const existingRedraw = options.chart.events.redraw

  options.chart.events.redraw = (event) => {
    if (existingRedraw) existingRedraw.call(this, event)

    const chart = event.target
    const targetXAxis = chart.xAxis[0]

    if ((targetXAxis.min !== lastViewXAxisMin) || (targetXAxis.max !== lastViewXAxisMax)) {
      proceedWithIconRender = true
    }

    if (!proceedWithIconRender) return true

    proceedWithIconRender = false
    lastViewXAxisMin = targetXAxis.min
    lastViewXAxisMax = targetXAxis.max

    windDirectionSeries.forEach((optionsSeries) => {
      const newData = []
      const chartSeries = chart.get(optionsSeries.id)

      optionsSeries.data
        .filter((optionsSeriesDataPoint) => (
          optionsSeriesDataPoint[0] >= targetXAxis.min && optionsSeriesDataPoint[0] <= targetXAxis.max
        ))
        .forEach((optionsSeriesDataPoint) => {
          const degrees = optionsSeriesDataPoint[2]
          const markerAngle = convertDegreesToIconAngle(degrees)
          const cardinal = optionsSeriesDataPoint[3]
          const marker = (typeof markerAngle === 'number')
            ? {
              enabled: false,
              symbol: `url(${iconCircularButtonArrow(24, markerAngle, optionsSeries.color)})`,
              radius: 24,
            }
            : (cardinal === 'CALM')
              ? {
                enabled: false,
                symbol: `url(${iconCircularButtonCalm(24, optionsSeries.color)})`,
                radius: 24,
              }
            : {
              enabled: false,
            }
          const x = optionsSeriesDataPoint[0]
          const y = optionsSeriesDataPoint[1]

          newData.push({ x, y, marker, degrees, cardinal })
        })

      const noDataPoints = Math.floor(window.innerWidth / 40)
      const incrementsPerItem = Math.floor(newData.length / noDataPoints)
      let iterator = 0

      newData.forEach((chartDataPoint) => {
        if (iterator++ === incrementsPerItem) {
          const degrees = chartDataPoint && chartDataPoint.degrees
          const markerAngle = convertDegreesToIconAngle(degrees)

          if (chartDataPoint && (typeof markerAngle === 'number')) {
            chartDataPoint.marker = {
              enabled: true,
              symbol: `url(${iconCircularButtonArrow(16, markerAngle, optionsSeries.color)})`,
              radius: 16,
            }
          } else if (chartDataPoint && chartDataPoint.cardinal === 'CALM') {
            chartDataPoint.marker = {
              enabled: true,
              symbol: `url(${iconCircularButtonCalm(16, optionsSeries.color)})`,
              radius: 16,
            }
          }

          iterator = 0
        }
      })

      chartSeries.setData(newData, false, null, false)
    })

    chart.redraw()
  }

  return options
}
